import { useSubscriptionCheck } from "./useSubscriptionCheck";
import { useTeamLead } from "./useTeamLead";

interface UseSubscriptionStatusOptions {
  userId: string | null;
}

export function useSubscriptionStatus({
  userId,
}: UseSubscriptionStatusOptions) {
  const { leadUid } = useTeamLead({ userId: userId });

  const {
    isSubscriptionValid: isUserSubscriptionValid,
    isCheckingSubscription: isCheckingUserSubscription,
  } = useSubscriptionCheck({
    userId,
  });

  console.log("67 " + isUserSubscriptionValid + " for userId " + userId)


  const {
    isSubscriptionValid: isLeadSubscriptionValid,
    isCheckingSubscription: isCheckingLeadSubscription,
  } = useSubscriptionCheck({
    userId: leadUid || null,
  });

  const hasActiveSubscription =
    isUserSubscriptionValid === true || isLeadSubscriptionValid === true;

  const isStillChecking =
    isCheckingUserSubscription || isCheckingLeadSubscription;

  return {
    hasActiveSubscription,
    isUserSubscriptionValid,
    isLeadSubscriptionValid: isLeadSubscriptionValid,
    isStillChecking,
    leadUid,
  };
}
